import oInfo from "../info.json";

//Multimedia
import Facebook from "../Multimedia/Icons/facebook.svg";
import Instagram from "../Multimedia/Icons/instagram.svg";
import Twitter from "../Multimedia/Icons/twitter.svg";

const ContactContainer = () => {
  const { sHeader, sAddress, sEmail, sTelephone } = oInfo.oContactPage;
  return (
    <section className="flex-row card" id="contact-section">
      <div className="flex-column flex-center card-content-column">
        <h2 className="card-header">{sHeader}</h2>
        <h3 className="flex-column center card-subheader banner-background">
          <a href="tel:+18007567074" className="subheader-span">
            {sTelephone}
          </a>
        </h3>
        <a href="mailto:killinketo@gmail.com">{sEmail}</a>
        <p className="card-content">{sAddress}</p>
        <div className="flex-row flex-center">
          <img src={Facebook} alt="Facebook" className="icon" />
          <img src={Instagram} alt="Instagram" className="icon" />
          <img src={Twitter} alt="Twitter" className="icon" />
        </div>
      </div>
      <div className="flex-column">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.9865453409066!2d-90.0834328844097!3d29.951065629931744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8620a5dd82214811%3A0x6e354b4a1659e3af!2sCaesars%20Superdome!5e0!3m2!1sen!2sus!4v1657059373367!5m2!1sen!2sus"
          title="Location"
          className="google-map"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactContainer;
